import {
  fetchCollection,
  deleteResource,
  baseRequest
} from './index'
import { reportSchema as schema } from '../schemas'
import FileSaver from 'file-saver'

const multipleKey = 'reports'

export const REPORTS_REQUEST = 'REPORTS_REQUEST'
export const REPORTS_SUCCESS = 'REPORTS_SUCCESS'
export const REPORTS_FAILURE = 'REPORTS_FAILURE'

function fetchReports (url, reload) {
  return fetchCollection({
    url,
    key: multipleKey,
    actions: [REPORTS_REQUEST, REPORTS_SUCCESS, REPORTS_FAILURE],
    schema,
    responseInterceptor: (response) => {
      return ({ ...response, reload })
    }
  })
}

export function loadReports (nextPage) {
  return (dispatch, getState) => {
    let {
      nextPageUrl
    } = getState().pagination.reports

    if (!nextPage) {
      nextPageUrl = '/reports'
    }

    return dispatch(fetchReports(nextPageUrl, !nextPage))
  }
}

export const DOWNLOAD_REPORT_REQUEST = 'DOWNLOAD_REPORT_REQUEST'
export const DOWNLOAD_REPORT_SUCCESS = 'DOWNLOAD_REPORT_SUCCESS'
export const DOWNLOAD_REPORT_FAILURE = 'DOWNLOAD_REPORT_FAILURE'

export function downloadReport(reportId) {
  return baseRequest({
    url: `/reports/${reportId}/download`,
    method: 'GET',
    actions: [ DOWNLOAD_REPORT_REQUEST, DOWNLOAD_REPORT_SUCCESS, DOWNLOAD_REPORT_FAILURE ],
    binary: true,
    responseInterceptor: (blob, response) => {
      let file = new Blob([blob], { type: 'application/zip' })
      FileSaver.saveAs(file, 'report.zip')
    }
  })
}

export const DELETE_REPORT_REQUEST = 'DELETE_REPORT_REQUEST'
export const DELETE_REPORT_SUCCESS = 'DELETE_REPORT_SUCCESS'
export const DELETE_REPORT_FAILURE = 'DELETE_REPORT_FAILURE'

export function deleteReport (reportId) {
  return deleteResource({
    url: `/reports/${reportId}`,
    actionPayload: { resourceId: reportId },
    actions: [ DELETE_REPORT_REQUEST, DELETE_REPORT_SUCCESS, DELETE_REPORT_FAILURE ]
  })
}




// WEBPACK FOOTER //
// ./src/actions/reports.js